import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { KeyRound } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { PasswordInput } from "@/components/PasswordInput";

const cls = "h-12 bg-slate-50 border-slate-200 text-center font-mono tracking-[0.5em] text-lg";

export default function SetupPin() {
  const { master, loginMaster } = useAuth();
  const navigate = useNavigate();
  const loc = useLocation();
  const [pin, setPin] = useState("");
  const [confirm, setConfirm] = useState("");
  const [pw, setPw] = useState(loc.state?.pw || "");
  const [busy, setBusy] = useState(false);
  const digits = (v) => v.replace(/\D/g, "").slice(0, 4);

  const save = async () => {
    if (pin.length !== 4) return toast.error("PIN must be 4 digits");
    if (pin === "1234") return toast.error("Choose a PIN other than the default 1234");
    if (pin !== confirm) return toast.error("PINs don't match");
    if (!pw) return toast.error("Enter your store password");
    setBusy(true);
    try {
      await api.post("/auth/change-pin", { role: "manager", new_pin: pin, master_password: pw });
      loginMaster(localStorage.getItem("zc_master_token"), { ...master, needs_pin_setup: false });
      toast.success("Manager PIN set");
      navigate("/staff", { replace: true });
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-white flex items-center justify-center p-5" data-testid="setup-pin-page">
      <div className="w-full max-w-sm space-y-4">
        <div className="text-center">
          <span className="w-14 h-14 mx-auto rounded-2xl bg-blue-50 text-blue-600 flex items-center justify-center mb-3"><KeyRound className="w-7 h-7" /></span>
          <h1 className="text-2xl font-extrabold font-head text-slate-900">Set Up Manager PIN</h1>
          <p className="text-sm text-slate-500 mt-1">Choose a 4-digit PIN for manager access (Billing, Revenue, Settings). Staff use their own PINs.</p>
        </div>
        <PasswordInput data-testid="setup-pin-new" inputMode="numeric" placeholder="New PIN" value={pin} onChange={(e) => setPin(digits(e.target.value))} className={cls} />
        <PasswordInput data-testid="setup-pin-confirm" inputMode="numeric" placeholder="Confirm PIN" value={confirm} onChange={(e) => setConfirm(digits(e.target.value))} className={cls} />
        {!loc.state?.pw && <PasswordInput data-testid="setup-pin-password" placeholder="Store password" value={pw} onChange={(e) => setPw(e.target.value)} className="h-12 bg-slate-50 border-slate-200" />}
        <Button data-testid="setup-pin-save" disabled={busy} onClick={save} className="w-full h-12 bg-[#1E3A8A] hover:bg-[#152a63] text-white font-bold">{busy ? "Saving…" : "Save PIN & Continue"}</Button>
      </div>
    </div>
  );
}
